<template>
    <div class="flex flex-col mx-auto max-w-3xl w-full text-left">
        <span class="my-64 text-center" v-if="!setup_intent_secret">Chargement du contrat...</span>

        <form action="/charge" @submit.prevent="submitPayment" method="post" id="payment-form" class="flex flex-col" v-show="setup_intent_secret">
            <InsuranceBlock :product="product" :type="type" />

            <div class="flex flex-col mb-3 mt-5">
                <div class="flex">
                    <div class="flex flex-col">
                        <span class="text-2xl mb-3">Assuré</span>

                        <div class="flex flex-col md:flex-row space-y-3 md:space-y-0 text-gray-600">
                            <div class="flex flex-col">
                                <span>{{ customer.gender }} {{ customer.firstname }} {{ customer.lastname }}</span>
                                <span>{{ customer.birthdate }}</span>
                                <span>{{ customer.email }}</span>
                                <span>{{ customer.phone }}</span>
                            </div>

                            <div class="flex flex-col md:ml-10">
                                <span>{{ customer.address_1 }} </span>
                                <span>{{ customer.address_2 }} </span>
                                <span>{{ customer.address_postcode }} {{ customer.address_city }}</span>
                                <span>{{ customer.address_country }} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <span class="text-2xl mb-3 mt-5">Prélèvement</span>

            <div class="flex items-start flex-col leading-none w-full">
                <label for="iban-element" class="mr-auto cursor-pointer">IBAN</label>
                <div id="iban-element"></div>
                <span class="mt-2 text-red-500 text-sm font-semibold" v-text="iban_error"></span>
            </div>

            <!-- Display mandate acceptance text. -->
            <div id="mandate-acceptance" class="hidden text-left text-sm text-gray-500 mt-5">
                By providing your payment information and confirming this payment, you
                authorise (A) Affinium and Stripe, our payment service provider, to
                send instructions to your bank to debit your account and (B) your bank to
                debit your account in accordance with those instructions. As part of your
                rights, you are entitled to a refund from your bank under the terms and
                conditions of your agreement with your bank. A refund must be claimed
                within 8 weeks starting from the date on which your account was debited.
                Your rights are explained in a statement that you can obtain from your
                bank. You agree to receive notifications for future debits up to 2 days
                before they occur.
            </div>
            
            <div class="ml-auto">
                <span v-if="isLoading">
                    <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                        <path class="fill-current" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                        </path>
                    </svg>
                </span>
                
                <input v-else type="submit" value="Valider l'adhésion" class="mt-5 p-4 px-8 cursor-pointer bg-green-500 hover:bg-green-600 text-white rounded ml-auto disabled:opacity-75 disabled:cursor-not-allowed"/>
            </div>
        </form>
    </div>
</template>

<script>
const axios = require('axios');
import AffInput from '@/components/inputs/AffInput'
import InsuranceBlock from '@/components/enrolment/InsuranceBlock'

export default {
    props: ['product', 'type', 'customer'],
    components: { AffInput, InsuranceBlock },
    data: function () {
        return {
            isLoading: false,
            stripe: Stripe('pk_test_TUfo07wjoQLSs5EyVABcdRbE00y1D1ggw6'),
            iban: null,
            setup_intent_secret: null,
            iban_error: null
        };
    },
    mounted: function () {
        this.getSetupIntentSecret();
    },
    methods:  {
        getSetupIntentSecret: function () {
            axios
            .post(process.env.VUE_APP_API_BASE_URL + 'xiaomi_care/shop/enroll/intent')
            .then(({data}) => {
                this.setup_intent_secret = data.setup_intent_secret;
                this.mountStripe();
            })
        },
        mountStripe: function () {
            const elements = this.stripe.elements({
                fonts: [{cssSrc: 'https://fonts.googleapis.com/css?family=IBM+Plex+Sans'}]
            });

            const style = {
                base: {
                    color: '#32325d',
                    fontSize: '18px',
                    fontFamily: 'IBM Plex Sans',
                    '::placeholder': {
                    color: '#aab7c4'
                    },
                    ':-webkit-autofill': {
                    color: '#32325d',
                    },
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a',
                    ':-webkit-autofill': {
                    color: '#fa755a',
                    },
                },
            };

            const options = {
                style,
                supportedCountries: ['SEPA'],
                // Elements can use a placeholder as an example IBAN that reflects
                // the IBAN format of your customer's country. If you know your
                // customer's country, we recommend passing it to the Element as the
                // placeholderCountry.
                placeholderCountry: 'FR',
            };


            // Create an instance of the IBAN Element
            this.iban = elements.create('iban', options);

            // Add an instance of the IBAN Element into the `iban-element` <div>
            this.iban.mount('#iban-element');

            this.iban.on('change', (event) => {
                if (event.error) {
                    this.iban_error = event.error.message;
                } else {
                    this.iban_error = null;
                }
            });
        },
        submitPayment: function () {
            this.isLoading = true;

            this.stripe.confirmSepaDebitSetup(
                this.setup_intent_secret,
                {
                    payment_method: {
                        sepa_debit: this.iban,
                        billing_details: {
                            name: this.customer.firstname + ' ' + this.customer.lastname,
                            email: this.customer.email,
                        },
                    }
                }
            )
            .then((result) => {
                if(result.setupIntent) {
                    this.completeEnroll(result.setupIntent.payment_method)
                } else {
                    this.isLoading = false;
                }
            })
        },
        completeEnroll: function (payment_method) {
            const payload = {
                name: this.customer.firstname + ' ' + this.customer.lastname,
                email: this.customer.email,
                payment_method: payment_method,
                type: this.type,
                customer: this.customer,
                product: this.product
            };
            
            axios
            .post(process.env.VUE_APP_API_BASE_URL + 'xiaomi_care/shop/enroll/complete', payload)
            .then(({data}) => {
                this.isLoading = false;
                this.$emit('enrolled');
            })
            .catch(() => {
                this.isLoading = false;
            })
        }
    }
}
</script>

<style scoped>
    #iban-element {
        @apply w-full px-3 py-2 mt-3 rounded outline-none appearance-none shadow-sm border border-gray-500;
    }

    #iban-element.StripeElement--focus {
        @apply shadow-outline;
    }
</style>